export default "__VITE_ASSET__CqBbVkc1__"